<div class="goal__wrapper">
  <ng-container *ngIf="progress$ | async as progress">
    <div class="progress progress-mdb--paybee">
      <div
        class="progress-bar bg-success progress-bar--paybee"
        role="progressbar"
        [ngStyle]="{'width.%': progress}"
        aria-valuenow="progress"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
  </ng-container>
  <ng-container *ngIf="summary$ | async as summary">
    <div class="goal__info w-100 overflow-hidden">
      <div class="widget__text--small text-truncate mb-md-1 mb-lg-2">Goal: {{ summary.goal | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
      <div class="widget__text--large text-truncate">{{ summary.total | currency:'USD':'symbol-narrow':'1.0-0' }}</div>
    </div>
  </ng-container>
  <app-icon-goal></app-icon-goal>
</div>